<script setup lang="ts">
import { ProgressIndicator, ProgressRoot } from "reka-ui";
import { computed } from "vue";

const props = defineProps<{
  type: "Documents" | "Whiteboards";
  current: number;
  limit: number;
}>();

const percentage = computed(() => {
  return props.current / props.limit * 100;
});

const statusColor = computed(() => {
  if (percentage.value > 100) return "bg-red-600";
  if (percentage.value >= 66) return "bg-orange-500";
  return "bg-blue-500";
});

const textColor = computed(() => {
  if (percentage.value > 100) return "text-red-600";
  if (percentage.value >= 66) return "text-orange-500";
  return "";
});
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex justify-between gap-1">
      <div class="text-sm font-medium text-slate-800">
        {{ type }}
      </div>
      <div class="text-sm" :class="textColor">
        {{ current }}/{{ limit }}
      </div>
    </div>
    <ProgressRoot
      :model-value="current > limit ? limit : current"
      :max="limit ?? 100"
      class="relative h-1.5 overflow-hidden rounded-full bg-slate-200"
    >
      <ProgressIndicator
        :style="`transform: translateX(-${100 - Math.min(percentage, 100)}%)`"
        class="size-full rounded-full transition-transform duration-1000 ease-in-out"
        :class="statusColor"
      />
    </ProgressRoot>
  </div>
</template>
